import { render, staticRenderFns } from "./CreateOrderModalSidebar.vue?vue&type=template&id=a2e03892&scoped=true"
import script from "./CreateOrderModalSidebar.vue?vue&type=script&lang=js"
export * from "./CreateOrderModalSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderModalSidebar.vue?vue&type=style&index=0&id=a2e03892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e03892",
  null
  
)

export default component.exports